import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Focusable } from '@ariakit/react';
import { forwardRef } from 'react';
import { CheckboxCheckmark } from '../Icons';
import * as Styles from './styles';
const Checkbox = ({ children, checked, disabled, hover, ...rest }) => {
    return (_jsxs(_Fragment, { children: [_jsx(Styles.Checkbox, { "$checked": checked, "$disabled": disabled, "$hover": hover, ...rest, children: _jsx(CheckboxCheckmark, {}) }), children] }));
};
const Label = ({ children, disabled, ...rest }) => {
    return (_jsx(Styles.Label, { "$disabled": disabled, ...rest, children: children }));
};
const Input = forwardRef(function Input({ disabled, ...rest }, ref) {
    return (_jsx(Focusable, { disabled: disabled, accessibleWhenDisabled: true, render: _jsx(Styles.HiddenInput, { ref: ref, ...rest }) }));
});
export const StyledCheckbox = {
    Checkbox,
    Label,
    Input,
    AriaKitCheckbox: Styles.AriaKitCheckbox,
};
//# sourceMappingURL=index.js.map